import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { getStorage } from "../../utils/storage";
import bloodCenterQuery from "../../utils/queries/bloodCenterQuery";
import bloodCenterSiteQuery from "../../utils/queries/bloodCenterSiteQuery";
import { Empty } from "../Empty";
import { donorNumber } from "../../utils/uniqueID";
import Separations from "../Production/ComponentSeparation/Separations";
import Transformations from "../Production/ComponentTransformation/Transformations";
import { Tabs } from "../Tabs";
import { Table } from "../Table";
import { DonorProfile } from "../Donors";
import { fetchRejectionStatus } from "../../utils/queries/rejectionStatus";
import { fetchBloodBanks } from "../../utils/queries/bloodBank";
import ShipmentInforamtion from "./ShipmentInforamtion";
import { ROLE_COLLECTIONS, ROLE_DONORS } from "../../constants/ROLES";
import { defineRole } from "../../utils/handleAccessRoles";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const shipmentStatusOptions = [
  { label: "Pending", value: "pending" },
  { label: "Received", value: "received" },
  { label: "Shipped", value: "shipped" },
  { label: "Cancelled", value: "cancelled" },
];

const inventoryStatusOptions = [
  { label: "In Stock", value: "INSTOCK" },
  { label: "Reserved", value: "RESERVED" },
  { label: "Reservation Cancelled", value: "RESERVATION_CANCELLED" },
  { label: "Pending", value: "PENDING" },
  { label: "Out of Stock", value: "OUTSTOCK" },
];

const statuses = [
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Transferred",
    value: "transferred",
  },
  {
    label: "Labelled",
    value: "labelled",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
  {
    label: "Expired",
    value: "expired",
  },
  {
    label: "Blocked",
    value: "blocked",
  },
  {
    label: "Archived",
    value: "archived",
  },
  {
    label: "Unarchived",
    value: "unarchived",
  },
  {
    label: "Reserve Transformation",
    value: "TRANSFORMATION_REVERSED",
  },
];

class NewInventory extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: {},
      isSubmitting: false,
      donation: [],
      isLoading: false,
      centers: [],
      centerSites: [],
      reason: "",
      shipmentDetails: {},
      user: {},
      adminInventoryStatus: null,
      isUpdatingInventoryStatus: false,
      adminStatus: null,
      isUpdatingStatus: false,
      adminStock: null,
      isUpdatingStock: false,
      adminShipmentStatus: null,
      isUpdatingShipmentStatus: false,
      centerSite: null,
    expiredDate: "",
    status: null,
    volume: "",
};
  }

  componentDidMount = async () => {
// eslint-disable-next-line no-unused-vars
    let { error } = this.state;

    const user = await getStorage();

    this.setState({
      code: donorNumber(4),
      user,
    });

    this.getCenters(true);

    if (this.props._id) {
      await this.setState({
        center: this.props.center?._id
          ? {
              label: this.props.center.name,
              value: this.props.center._id,
            }
          : null,
        centerSite: this.props.centerSite?._id
          ? {
              label: this.props.centerSite.name,
              value: this.props.centerSite._id,
            }
          : null,
        status: this.props.status
          ? {
              label: this.props.status,
              value: this.props.status,
            }
          : null,
        volume: this.props.volume,
        expiredDate: this.props.expiredDate,
        available: {
          label: this.props.available + "",
          value: this.props.available + "",
        },
        reason: this.props.blockInfo
          ? {
              label: this.props.blockInfo.blockReason,
              value: this.props.blockInfo.blockReason,
            }
          : null,
      });
    }

    // if (!this.state.donationId) {
    //   error.errorMessage =
    //     language[this.props.defaultLanguage].donation_required;
    // }
  };

  // getTemperatures = async () => {
  //   try {
  //     let { status } = this.state;
  //     this.setState({
  //       isFetchingTemperatures: true,
  //     });

  //     const { data } = await fetchTransportationTemperatures(
  //       this.props.defaultLanguage,
  //       { page: 1, limit: 100 }
  //     );

  //     const temperatureRange = findTemperatureRange(
  //       this.state.transportationTemperature,
  //       data
  //     );

  //     let inventoryStatuses = temperatureRange.map((el) => {
  //       return {
  //         label: el.decision,
  //         value: el.decision,
  //       };
  //     });

  //     if (inventoryStatuses && inventoryStatuses.length === 1) {
  //       status = inventoryStatuses[0];
  //     }

  //     this.setState({
  //       temperatures: data,
  //       isFetchingTemperatures: false,
  //       inventoryStatuses,
  //       status,
  //     });
  //   } catch (error) {
  //     toastMessage("error", error);

  //     this.setState({
  //       isFetchingTemperatures: false,
  //     });
  //   }
  // };

  getCenters = async (isFetchingCenter, search = {}) => {
    try {
      this.setState({
        isFetchingCenter,
      });

      const data = await bloodCenterQuery(this.props.defaultLanguage, {
        type: "dropdown",
        ...search,
      });

      this.setState({
        centers: data,
        isFetchingCenter: false,
      });

      return data;
    } catch (error) {
      this.setState({ isFetchingCenter: false });
    }
  };

  getSites = async (isFetchingSite, center) => {
    if (!center) return;
    try {
      this.setState({
        isFetchingSite,
      });

      const data = await bloodCenterSiteQuery(this.props.defaultLanguage, {
        center,
        type: "dropdown",
      });

      this.setState({
        centerSites: data,
        isFetchingSite: false,
      });

      return data;
    } catch (error) {
      this.setState({ isFetchingSite: false });
    }
  };

  onChangeText = async (field, e) => {
// eslint-disable-next-line no-unused-vars
    let { error, label } = this.state;
    let inputValue = e && e?.target ? e?.target?.value : e;

    delete error[field];

    await this.setState({
      [field]: inputValue,
      error,
    });

    if (field === "center") {
      this.setState({ site: null });
      this.getSites(true, inputValue.value);
    }

    if (this.state.weight === "") {
      this.setState({ label: null });

      return;
    }

    let { status } = this.state;

    if (field === "reason") {
      if (inputValue?.status) {
        for (let el of statuses) {
          if (inputValue?.status === el.value) {
            status = el;
          }
        }
      } else if (this.props.status) {
        status = {
          label: this.props.status,
          value: this.props.status,
        };
      }

      this.setState({
        status,
      });
    }
  };

  validateForm() {
    let { expiredDate, error, centerSite, center, volume, status, reason } =
      this.state;

    if (!expiredDate) {
      error.expiredDate =
        language[this.props.defaultLanguage].expiration_date_required;
    }

    if (!volume) {
      error.volume = language[this.props.defaultLanguage].volume_required;
    }

    if (!center) {
      error.center = language[this.props.defaultLanguage].center_required;
    }

    if (!centerSite) {
      error.centerSite = language[this.props.defaultLanguage].site_required;
    }

    if (!status) {
      error.status = language[this.props.defaultLanguage].status_required;
    }

    if (!reason) {
      error.reason = language[this.props.defaultLanguage].reason_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      let { _id } = this.props;
      let { volume, expiredDate, center, centerSite, status, reason } =
          this.state,
        url = `${API_URL}/inventory`,
        method = "PUT",
        user = await getStorage();

      let requestedBody = {
        expiredDate,
        volume,
        center: center.value,
        centerSite: centerSite.value,
        status: status.value,
        reason: reason.label,
        reasonId: reason._id,
        id: _id,
        component: this.props?.component?._id,
        donation: this.props.donation?._id,
      };

      const options = {
        method,
        url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
        data: requestedBody,
      };
      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              method === "PUT" ? "update_data_success" : "add_data_success"
            ]
          );

          this.props.getData(true);
          this.props.handleCloseModal();
        })
        .catch((error) => {
          this.setState({ isSubmitting: false });
          toastMessage("error", error);
        });
    }
  };

  onUpdateInventoryStatus = async () => {
    const { adminInventoryStatus } = this.state;
    if (!adminInventoryStatus) {
      return toastMessage("error", "Please select an inventory status");
    }
    this.setState({ isUpdatingInventoryStatus: true });
    const user = await getStorage();
    try {
      await axios({
        method: "PUT",
        url: `${API_URL}/inventory`,
        data: { id: this.props._id, inventoryStatus: adminInventoryStatus.value },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
      });
      toastMessage("success", "Inventory status updated successfully");
      this.setState({ isUpdatingInventoryStatus: false });
      this.props.getData(true);
      this.props.handleCloseModal();
    } catch (error) {
      toastMessage("error", error);
      this.setState({ isUpdatingInventoryStatus: false });
    }
  };

  onUpdateStatus = async () => {
    const { adminStatus } = this.state;
    if (!adminStatus) return toastMessage("error", "Please select a status");
    this.setState({ isUpdatingStatus: true });
    const user = await getStorage();
    try {
      await axios({
        method: "PUT",
        url: `${API_URL}/inventory`,
        data: {
        id: this.props._id,
        status: adminStatus.value,
        ...(adminStatus.value === "labelled" && { isLabeled: true }),
      },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
      });
      toastMessage("success", "Status updated successfully");
      this.setState({ isUpdatingStatus: false });
      this.props.getData(true);
      this.props.handleCloseModal();
    } catch (error) {
      toastMessage("error", error);
      this.setState({ isUpdatingStatus: false });
    }
  };

  onUpdateShipmentStatus = async () => {
    const { adminShipmentStatus } = this.state;
    if (!adminShipmentStatus) return toastMessage("error", "Please select a shipment status");
    this.setState({ isUpdatingShipmentStatus: true });
    const user = await getStorage();
    try {
      await axios({
        method: "PUT",
        url: `${API_URL}/inventory`,
        data: { id: this.props._id, shipmentInfo: { status: adminShipmentStatus.value } },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
      });
      toastMessage("success", "Shipment status updated successfully");
      this.setState({ isUpdatingShipmentStatus: false });
      this.props.getData(true);
      this.props.handleCloseModal();
    } catch (error) {
      toastMessage("error", error);
      this.setState({ isUpdatingShipmentStatus: false });
    }
  };

  onUpdateStock = async () => {
    const { adminStock } = this.state;
    if (!adminStock) return toastMessage("error", "Please select a stock");
    this.setState({ isUpdatingStock: true });
    const user = await getStorage();
    try {
      await axios({
        method: "PUT",
        url: `${API_URL}/inventory`,
        data: { id: this.props._id, stock: adminStock.value },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
      });
      toastMessage("success", "Stock updated successfully");
      this.setState({ isUpdatingStock: false });
      this.props.getData(true);
      this.props.handleCloseModal();
    } catch (error) {
      toastMessage("error", error);
      this.setState({ isUpdatingStock: false });
    }
  };

  getRejectionStatus = async (isLoadingReason, search = {}) => {
    try {
      this.setState({ isLoadingReason });
      const { data } = await fetchRejectionStatus("dropdown", {
        page: 0,
        limit: 50,
        type: "INVENTORY",
        ...search,
      });

      this.setState({
        isLoadingReason: false,
      });

      return data;
    } catch (error) {
      this.setState({
        isLoadingReason: false,
      });
      toastMessage("error", error);
    }
  };

  renderInventory() {
    return (
      <>
        <div>
          {!this.props._id ? (
            <center>
              <Empty title={language[this.props.defaultLanguage].no_data} />
            </center>
          ) : Object.keys(this.props.donation).length > 0 ? (
            <>
              {this.props.blockInfo?.blocked && (
                <div className="alert alert-danger">
                  {this.props?.blockInfo?.blockReason}
                </div>
              )}
              <br />

              <div className="card-body">
                <div className="row">
                  <>
                    <div className="col-md-4">
                      <Input
                        label={language[this.props.defaultLanguage].product}
                        value={this.props.code}
                        disabled
                      />
                    </div>
                    <div className="col-md-4">
                      <Input
                        label={language[this.props.defaultLanguage].component}
                        value={this.props.name}
                        disabled
                      />
                    </div>

                    <div className="col-md-4">
                      <Input
                        label={language[this.props.defaultLanguage].blood_group}
                        value={this.props.bloodGroup}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={
                          language[this.props.defaultLanguage]
                            .blood_grouping_result
                        }
                        value={this.props.bloodGroupingResult}
                        disabled
                        textarea
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={
                          language[this.props.defaultLanguage].serology_result
                        }
                        value={this.props.serologyResult}
                        disabled
                        textarea
                      />
                    </div>
                    <div className="col-md-6">
                      <Select
                        loadOptions={(e) => this.getCenters(true, { q: e })}
                        placeholder={
                          language[this.props.defaultLanguage].select
                        }
                        label={language[this.props.defaultLanguage].center}
                        value={this.state?.center}
                        error={this.state.error.center}
                        onChange={(e) => this.onChangeText("center", e)}
                        disabled={
                          this.props?.inventoryStatus?.toUpperCase() ===
                            "RESERVED" ||
                          this.props.status?.toUpperCase() === "ARCHIVED"
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <Select
                        options={this.state.centerSites}
                        label={language[this.props.defaultLanguage].site}
                        value={this.state.centerSite}
                        error={this.state.error.centerSite}
                        onChange={(e) => this.onChangeText("centerSite", e)}
                        disabled={
                          this.props?.inventoryStatus?.toUpperCase() ===
                            "RESERVED" ||
                          this.props.status?.toUpperCase() === "ARCHIVED"
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={language[this.props.defaultLanguage].volume}
                        value={this.state.volume}
                        error={this.state.error.volume}
                        onChange={(e) => this.onChangeText("volume", e)}
                        type="number"
                        disabled={
                          this.props?.inventoryStatus?.toUpperCase() ===
                            "RESERVED" ||
                          this.props.status?.toUpperCase() === "ARCHIVED"
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={
                          language[this.props.defaultLanguage]
                            .transportation_temperature
                        }
                        placeholder={
                          language[this.props.defaultLanguage]
                            .transportation_temperature_placeholder
                        }
                        value={this.props.component.storageTemperature?.name}
                        disabled
                      />
                    </div>

                    <div className="col-md-12">
                      <Input
                        label={
                          language[this.props.defaultLanguage].expired_date
                        }
                        value={this.state.expiredDate}
                        error={this.state.error.status}
                        onChange={(e) => this.onChangeText("status", e)}
                        type="datetime-local"
                        disabled={
                          this.props?.inventoryStatus?.toUpperCase() ===
                            "RESERVED" ||
                          this.props.status?.toUpperCase() === "ARCHIVED"
                        }
                      />
                    </div>

                    {this.props?.blockInfo?.blocked && (
                      <div className="col-md-12">
                        <Input
                          label={
                            language[this.props.defaultLanguage].block_reason
                          }
                          placeholder={
                            language[this.props.defaultLanguage]
                              .reason_placeholder
                          }
                          value={this.props.blockInfo.blockReason}
                          disabled
                        />
                      </div>
                    )}
                    {this.props?.rejectionInfo?.rejected && (
                      <div className="col-md-12">
                        <Input
                          label={
                            language[this.props.defaultLanguage].reject_reason
                          }
                          placeholder={
                            language[this.props.defaultLanguage]
                              .reason_placeholder
                          }
                          value={this.props.rejectionInfo.reason}
                          disabled
                        />
                      </div>
                    )}
                    {this.props?.reverseInfo?.reversed && (
                      <div className="col-md-12">
                        <Input
                          label={
                            language[this.props.defaultLanguage].reverse_reason
                          }
                          placeholder={
                            language[this.props.defaultLanguage]
                              .reason_placeholder
                          }
                          value={this.props.reverseInfo.reason}
                          disabled
                        />
                      </div>
                    )}
                    {this.props?.concentrationValue && (
                      <div className="col-md-12">
                        <Input
                          label={
                            language[this.props.defaultLanguage].concentration
                          }
                          value={this.props.concentrationValue}
                          disabled
                        />
                      </div>
                    )}
                  </>
                </div>

                <div className="col-md-12">
                  <Select
                    loadOptions={(e) =>
                      this.getRejectionStatus(true, {
                        q: e,
                      })
                    }
                    label={language[this.props.defaultLanguage].reason}
                    placeholder={
                      language[this.props.defaultLanguage].reason_placeholder
                    }
                    value={this.state.reason}
                    required
                    onChange={(e) => this.onChangeText("reason", e)}
                    error={this.state.error.reason}
                    isLoading={this.state.isLoadingReason}
                    disabled={
                      this.props?.inventoryStatus?.toUpperCase() ===
                        "RESERVED" ||
                      this.props.status?.toUpperCase() === "ARCHIVED"
                    }
                  />
                </div>

                <div className="col-md-12">
                  <Select
                    options={statuses}
                    label={language[this.props.defaultLanguage].status}
                    value={this.state.status}
                    error={this.state.error.status}
                    onChange={(e) => this.onChangeText("status", e)}
                    disabled={
                      this.props?.inventoryStatus?.toUpperCase() ===
                        "RESERVED" ||
                      this.props.status?.toUpperCase() === "ARCHIVED"
                    }
                  />
                </div>

                {this.state.user?.role === "superAdmin" && (
                  <div
                    style={{
                      borderTop: "2px dashed #dee2e6",
                      margin: "1.5rem 0 0.5rem",
                      paddingTop: "1rem",
                    }}
                  >
                    <div style={{ marginBottom: "0.75rem" }}>
                      <span
                        style={{
                          fontWeight: 600,
                          fontSize: "0.85rem",
                          color: "var(--primary-color)",
                        }}
                      >
                        Admin Controls
                      </span>
                      <span
                        style={{ marginLeft: "0.5rem", fontSize: "0.78rem", color: "#6c757d" }}
                      >
                        — Override status, inventory status, shipment status, and stock
                      </span>
                    </div>
                    <div className="row align-items-end">
                      <div className="col-md-8">
                        <Select
                          options={statuses}
                          label="Status"
                          value={this.state.adminStatus}
                          onChange={(e) => this.setState({ adminStatus: e })}
                        />
                      </div>
                      <div className="col-md-4" style={{ paddingBottom: "1rem" }}>
                        <Button
                          text="Update"
                          onPress={this.onUpdateStatus}
                          isSubmitting={this.state.isUpdatingStatus}
                        />
                      </div>
                    </div>
                    <div className="row align-items-end">
                      <div className="col-md-8">
                        <Select
                          options={inventoryStatusOptions}
                          label="Inventory Status"
                          value={this.state.adminInventoryStatus}
                          onChange={(e) => this.setState({ adminInventoryStatus: e })}
                        />
                      </div>
                      <div className="col-md-4" style={{ paddingBottom: "1rem" }}>
                        <Button
                          text="Update"
                          onPress={this.onUpdateInventoryStatus}
                          isSubmitting={this.state.isUpdatingInventoryStatus}
                        />
                      </div>
                    </div>
                    <div className="row align-items-end">
                      <div className="col-md-8">
                        <Select
                          options={shipmentStatusOptions}
                          label="Shipment Status"
                          value={this.state.adminShipmentStatus}
                          onChange={(e) => this.setState({ adminShipmentStatus: e })}
                        />
                      </div>
                      <div className="col-md-4" style={{ paddingBottom: "1rem" }}>
                        <Button
                          text="Update"
                          onPress={this.onUpdateShipmentStatus}
                          isSubmitting={this.state.isUpdatingShipmentStatus}
                        />
                      </div>
                    </div>
                    <div className="row align-items-end">
                      <div className="col-md-8">
                        <Select
                          loadOptions={(e) =>
                            fetchBloodBanks(this.props.defaultLanguage, {
                              type: "dropdown",
                              q: e,
                              limit: 100,
                            })
                          }
                          label="Stock"
                          value={this.state.adminStock}
                          onChange={(e) => this.setState({ adminStock: e })}
                        />
                      </div>
                      <div className="col-md-4" style={{ paddingBottom: "1rem" }}>
                        <Button
                          text="Update"
                          onPress={this.onUpdateStock}
                          isSubmitting={this.state.isUpdatingStock}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {!this.props.isDisabled && (
                <div className="modal-footer">
                  <Button
                    text={language[this.props.defaultLanguage].cancel}
                    onPress={this.props.handleCloseModal}
                    className="btn-default"
                  />
                  {this.props?.inventoryStatus?.toUpperCase() !== "RESERVED" &&
                    this.props.status?.toUpperCase() !== "ARCHIVED" && (
                      <Button
                        text={language[this.props.defaultLanguage].submit}
                        onPress={this.onSubmit.bind(this)}
                        isSubmitting={this.state.isSubmitting}
                      />
                    )}
                </div>
              )}
            </>
          ) : (
            <Empty title={language[this.props.defaultLanguage].not_found} />
          )}
        </div>
      </>
    );
  }

  returnDonationTableHeaders() {
    const canReadDonorInformation = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_DONORS,
      operation: "read",
    });
    const canReadDonationInformation = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_COLLECTIONS,
      operation: "read",
    });
    let headers = [
      {
        title: language[this.props.defaultLanguage].donation_number,
        key: "donationNumber",
        type: canReadDonationInformation && "link",
        onPress: (item) => {
          window.location.href = `/dashboard/donations/${item._id}/${
            item.donor._id
          }/${item.donor.firstName + " " + item.donor.lastName}`;
        },
        copyEnabled: true,
        styles: { textTransform: "uppercase" },
      },
      {
        title: language[this.props.defaultLanguage].donor,
        key: "donor.donorNumber",
        type: canReadDonorInformation && "link",
        onPress: (item) =>
          (window.location.href = `/dashboard/donations/${item._id}/${
            item.donor._id
          }/${item.donor.firstName + " " + item.donor.lastName}`),
        styles: { textTransform: "uppercase" },
        copyEnabled: true,
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "bloodInfo.bloodGroup",
        styles: { textTransform: "uppercase" },
      },
      {
        title: language[this.props.defaultLanguage].volume,
        key: "bloodInfo.volume",
      },
      {
        title: language[this.props.defaultLanguage].collection_date,
        key: "collectionDate",
        isMoment: true,
        formatTime: "lll",
        styles: { textTransform: "uppercase" },
      },
      {
        title: language[this.props.defaultLanguage].center,
        key: "center.name",
      },
      {
        title: language[this.props.defaultLanguage].center_site,
        key: "centerSite.name",
      },
      {
        title: language[this.props.defaultLanguage].equipment,
        key: "equipment",
        render: (item) =>
          item.equipment
            ? `${item.equipment.code || ""} ${item.equipment.name || ""}`.trim() || "-"
            : "-",
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
    ];

    return headers;
  }

  renderDonation() {
    if (!this.props.donation) return;
    return (
      <div className="card-body">
        <Table
          data={[this.props.donation]}
          headers={this.returnDonationTableHeaders()}
        />
      </div>
    );
  }

  renderSeparations() {
    if (!this.props.donation) return;
    return (
      <div className="card-body">
        <Separations type="separation" donationId={this.props.donation?._id} />
      </div>
    );
  }

  renderTransformation() {
    if (!this.props.donation) return;
    return (
      <div className="card-body">
        <Transformations donationId={this.props.donation._id} />
      </div>
    );
  }

  renderDonor() {
    if (!this.props.donation) return;
    return (
      <div className="card-body">
        <DonorProfile donorId={this.props.donation.donor?._id} />
      </div>
    );
  }

  render() {
    const canReadDonorInformation = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_DONORS,
      operation: "read",
    });
    return (
      <>
        {this.props?.patient?._id && (
          <div>
            <div className="card-header">
              {canReadDonorInformation && (
                <div className="card-header-item">
                  <span>{language[this.props.defaultLanguage].donor}:</span>
                  <span className="text-bold ">
                    {this.props.donation.donor?.firstName +
                      " " +
                      this.props.donation.donor?.lastName}
                  </span>
                </div>
              )}

              <div className="card-header-item">
                <span>{language[this.props.defaultLanguage].patient}:</span>
                <span className="text-bold ">
                  {this.props.patient?.firstName +
                    " " +
                    this.props.patient?.lastName}
                </span>
              </div>
              <div className="card-header-item">
                <span>{language[this.props.defaultLanguage].blood_group}:</span>
                <span className="text-bold ">
                  {this.props.donation?.bloodGroup}
                </span>
              </div>
              <div className="card-header-item">
                <span>{language[this.props.defaultLanguage].patient_id}:</span>
                <span className="text-bold ">
                  {this.props.patient?.patientId}
                </span>
              </div>
            </div>
          </div>
        )}
        <Tabs
          options={[
            {
              title: language[this.props.defaultLanguage].inventory,
              data: this.renderInventory(),
            },
            {
              title: language[this.props.defaultLanguage].shipments,
              data: <ShipmentInforamtion inventory={this.props._id} />,
            },
            {
              title: language[this.props.defaultLanguage].separation,
              data: this.renderSeparations(),
            },
            {
              title: language[this.props.defaultLanguage].transformation,
              data: this.renderTransformation(),
            },
            {
              title: language[this.props.defaultLanguage].donation_information,
              data: this.renderDonation(),
            },
            {
              title: language[this.props.defaultLanguage].donor_information,
              data: this.renderDonor(),
            },
          ]}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewInventory);
